import { TLEventList } from '../lib/ab/event';
import { ABScreen } from '../lib/ab/screen';
import { abGetDefaultCity, makeCitySegmented } from '../lib/ab/widgets-home';
import { aTrackPage } from '../lib/mdl/a-track';
import { c_event_tags, cEventTagName } from '../lib/mdl/c-event-tag';
import { legacyEventsGetActiveByTagId } from '../lib/mdl/zzz-legacy-open-events';
import { the_login_scope, the_user } from '../lib/me/login';
import { UIButton } from '../lib/ui/component/button';
import { $el } from '../lib/ui/elements';
import { UIScreen } from '../lib/ui/screen';
import { uiSetTransition } from '../lib/ui/transition';
import { UIViewSpec } from '../lib/ui/view';
import { $on } from '../lib/y/events';
import { $i18n, yGetI18N, yIsEmptyI18N } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { $id } from '../lib/y/types';
import { HomeMenu } from './menu';

export class HomeTagScreen extends ABScreen {
    constructor(private _slug: string) {
        super({ menu: new HomeMenu });
    }

    protected override fillContent(content: UIViewSpec) {
        const slug = this._slug;
        const tag = c_event_tags.all.find(t => t.slug == slug)!;

        const promise = legacyEventsGetActiveByTagId(tag.id).then(events => {
            const list = new TLEventList('tag', 'list', 'event', events, { filter: tag.flags.show_future ? 'future' : 'active', sort: tag.sort_order });

            const text_block = $el.B([
                $el.P('bigtitle', cEventTagName(tag)),
                !yIsEmptyI18N(tag.description) && $el.P('narrow', yGetI18N(tag.description)),
                $el.DIV('s-small')
            ]);

            uiSetTransition('tag-info', text_block);

            const section = $el.SECTION('w-block', text_block);

            if(tag.flags.show_cities) {
                const segmented = makeCitySegmented({ kind: 'k-under' });
                $on(segmented, 'value', city => { list.city = city });
                segmented.value = abGetDefaultCity().id;

                section.ui_add($el.DIV('l-form m-center', [segmented]));
            } else if(!tag.flags.show_all_cities && the_user) {
                list.city = the_user.city_id;
            }

            section.ui_add([
                list,
                $el.DIV('l-form m-center', [
                    $el.DIV('s-tiny'),
                    new UIButton({
                        kind: 'k-text', classes: 'r-right-now', title: $i18n.tl.b_back_to_events, on_click: () => {
                            $location.navigate(the_login_scope ? [] : ['right-now']);
                        }
                    })
                ])
            ]);

            content.ui_add(section);
        });

        aTrackPage('tag', { event_tag: $id.idToObjectId(tag.id) });

        return promise;
    }

    override onWillTransitionTo(_screen: UIScreen) {
        return this._slug ? { tag_slug: this._slug } : undefined;
    }
}
